import React from "react";
import * as PropTypes from "prop-types";
import ComponentWithIeFallback from "../../widgets/ComponentWithIeFallback";
import SimpleThemeIntroduction from "./SimpleThemeIntroduction";
import ThemeIntroduction from "./ThemeIntroduction";

const ThemeIntroductionController = props => (
  <ComponentWithIeFallback
    fallbackComponent={<SimpleThemeIntroduction {...props} />}
  >
    <ThemeIntroduction {...props} />
  </ComponentWithIeFallback>
);

ThemeIntroductionController.propTypes = {
  reference: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]).isRequired
};

export default ThemeIntroductionController;
